import { node, string } from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
const StyledFloatingLabel = styled.section`
  .float-label {
    position: relative;
    margin-bottom: 4px !important;
    input{
      border: ${(props) => props.theme.lightBorder} solid 1px;
      border-radius: 3px;
      padding:14px 10px;
      height: auto;
    }
    textarea.ant-input{
      padding: 15px 10px;
    }
  }
  .label {
    font-size: 12px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: 15px;
    opacity: 0.5;
    transition: 0.2s ease all;
  }
  .label-float {
    top: 2px !important;
    font-size: 0.75em !important;
    opacity: 0.5;
    
  }
  .ant-select-selection{
    &.ant-select-selection--single{
      height: auto;
      padding: 8px 0px;
      .ant-select-selection__rendered{
        &:focus{
          outline: none;
        }
        input{
          border:none;
        }
      }
    }
  }

`;

class FloatingLabel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focus: false,
    };
  }

  render() {
    const { children, label, value } = this.props;

    const labelClass =
    this.state.focus || (value && value.length !== 0) ? 'label label-float' : 'label';

    return (
      <StyledFloatingLabel>
        <div
          className="float-label"
          onBlur={() => this.setState({ focus: false })}
          onFocus={() => this.setState({ focus: true })}
        >
          {children}
          <label className={labelClass}>{label}</label>
        </div>
      </StyledFloatingLabel>
    );
  }
}
FloatingLabel.propTypes = {
  children: node.isRequired,
  label: string.isRequired,
  value: string,
};
FloatingLabel.defaultProps = {
  value: '',
};
export default FloatingLabel;



// WEBPACK FOOTER //
// client/components/FloatingLabel/index.js